module.exports = "pod install\n"